// src/pages/RegistroDescuento.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../Config';

const RegistroDescuento = () => {
  const [productoId, setProductoId] = useState('');
  const [productos, setProductos] = useState([]);
  const [porcentaje, setPorcentaje] = useState('');
  const [fecha, setFecha] = useState('');
  const [mensaje, setMensaje] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProductos = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/productos`);
        setProductos(response.data);
      } catch (error) {
        console.error('Error al cargar productos', error);
      }
    };
    fetchProductos();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/api/descuentos`, {
        productoId: parseInt(productoId),
        porcentajeDescuento: parseFloat(porcentaje),
        fecha: fecha || null
      });
      setMensaje('✅ Descuento registrado correctamente');
      setProductoId('');
      setPorcentaje('');
      setFecha('');
      setTimeout(() => navigate('/admin-promociones'), 1500);
    } catch (error) {
      console.error(error);
      setMensaje('❌ Error al registrar descuento');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4">Registrar Descuento</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block mb-1">Producto:</label>
            <select
              value={productoId}
              onChange={(e) => setProductoId(e.target.value)}
              required
              className="w-full border p-2 rounded"
            >
              <option value="">Seleccione un producto</option>
              {productos.map((prod) => (
                <option key={prod.id} value={prod.id}>{prod.nombre}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block mb-1">Porcentaje (%):</label>
            <input
              type="number"
              value={porcentaje}
              onChange={(e) => setPorcentaje(e.target.value)}
              required
              min="0"
              max="100"
              step="0.01"
              className="w-full border p-2 rounded"
            />
          </div>
          <div>
            <label className="block mb-1">Fecha:</label>
            <input
              type="date"
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
              required
              className="w-full border p-2 rounded"
            />
          </div>
          <button
            type="submit"
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            Guardar
          </button>
        </form>
        {mensaje && <p className="mt-4 text-center">{mensaje}</p>}
      </div>
    </div>
  );
};

export default RegistroDescuento;
